import { DatasetItem } from '../../../types/types';
import { DEFAULT_COLUMN_WIDTHS, FALLBACK_COLUMN_WIDTH } from '../constants';

/**
 * Width of a column in em — the same unit the grid uses for minWidth
 * (getColumns renders `${minWidth}em`). Falls back to a per-type default so a
 * definition without minWidth still prints a sane table.
 */
export const resolveColumnWidthEm = (item: DatasetItem): number => {
  if (typeof item.minWidth === 'number' && item.minWidth > 0) {
    return item.minWidth;
  }

  return DEFAULT_COLUMN_WIDTHS[item.type ?? ''] ?? FALLBACK_COLUMN_WIDTH;
};
